// utils/ProtectUser.js
import { useSelector } from 'react-redux'
import { Navigate, Outlet } from 'react-router-dom'

const ProtectUser = () => {
    const { userInfo } = useSelector(state => state.auth)
    
    if (!userInfo) {
        return <Navigate to='/login' />
    }

    // Redirect to verification page if not verified
    if (!userInfo.verified) {
        return <Navigate to='/verify-email' />
    }

    return <Outlet />
}

export default ProtectUser